
import Component from '../../../assets/scripts/modules/component';
import State from '../../../assets/scripts/modules/state';
import {pagination} from '../../../assets/scripts/modules/pagination';

const Swiper = require('swiper/dist/js/swiper.min');

const IDLE_TIMEOUT = 2000; // when does the gallery UI go byebye

class Gallery extends Component {
  constructor() {
    super(...arguments);
  }

  init() {
    this.container = this.element.querySelector('.swiper-container');
    this.wrapper = this.element.querySelector('.swiper-wrapper');
    this.pagination = this.element.querySelector('.swiper-pagination');
    this.buttonPrev = this.element.querySelector('.swiper-button--prev');
    this.buttonNext = this.element.querySelector('.swiper-button--next');
    this.buttonClose = this.element.querySelector('.swiper-button--close');

    this.uiTimer = null;

    // this.backgroundImage = '/static/media/pages/generic-content/floor-building.jpg';
    // this.galleryCaption = 'Alt tag of the image';

    this.instance = null;
    this.swiperStartIndex = 2;
    this.pictures = [];
    this.galleryInitialized = false;

    let imageIndex = 0;

    [...document.querySelectorAll('[data-add-me-to-gallery]')].forEach((element) => {
      /* Add the index to the gallery image */
      let picture = element.querySelector('picture');
      picture.setAttribute('data-gallery-index', imageIndex);
      element.setAttribute('data-gallery-index', imageIndex);
      let caption = element.getAttribute('data-gallery-image-caption');
      let imageurl = element.getAttribute('data-gallery-image');
      this.renderSlide(imageurl, caption);
      imageIndex++;
    });

    this.captions = [...document.querySelectorAll('.gallery--caption')];

    window.addEventListener('gallery:add', (event) => {
      const picture = event.detail;
      this.add(picture);
    });

    window.addEventListener('gallery:open', (event) => {
      this.swiperStartIndex = parseInt(event.detail.pictureIndex);
      this.open();
    });
  }

  initSwiper() {
    let startIndex = this.swiperStartIndex;
    this.instance = new Swiper(this.container, {
      autoPlay: false,
      // controlBy: 'container',
      direction: 'horizontal',
      effect: 'slide',
      grabCursor: false,
      keyboard: false,
      initialSlide: startIndex,
      loop: false,
      resistanceRatio: 0,
      roundLengths: true, // Prevents dragging fuzzyness
      setWrapperSize: true, // Fix for Firefox / IE11 for flex icm. padding-bottom
      slidesPerView: 1,
      spaceBetween: 0,
      touchRatio: 1,
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev,
      },
      pagination: {
        el: this.pagination,
        clickable: true,
        type: 'custom',
        renderCustom: pagination,
      },
      on: {
        init: this.listenToMouse.bind(this),
        transitionStart: this.hideCaptions.bind(this),
        sliderMove: this.hideCaptions.bind(this),
        transitionEnd: this.showCaptions.bind(this),
      },
    });
  }

  deactivateUI() {
    this.element.classList.add('ui__state--idle');
  }
  activateUI() {
    this.element.classList.remove('ui__state--idle');
  }

  listenToMouse() {

    // TODO do something with tap for touch devices? or maybe it already works automagical :P
    this.resetTimerRef = this.resetTimer.bind(this);
    window.addEventListener('mousemove', this.resetTimerRef);
    // TODO throttle this or interval somehow mouse movement

    this.uiTimer = setTimeout(() => {
        this.deactivateUI();
    }, IDLE_TIMEOUT);
  }

  resetTimer() {
    // reset idletimer and activate the UI in any case
    clearTimeout(this.uiTimer);
    this.activateUI();
    this.uiTimer = setTimeout(() => {
        this.deactivateUI();
    }, IDLE_TIMEOUT);
  }

  killTimer() {
    clearTimeout(this.uiTimer);
  }

  /**
   * Copies images from the page and adds them to the gallery.
   */
  initGallery() {
    return new Promise((resolve) => {
      this.galleryInitialized = true;

      requestAnimationFrame(() => {
        this.initSwiper();

        this.buttonClose.addEventListener('click', () => {
          this.close();
        });

        resolve();
      });
    });
  }

  add(pictureElement) {
    this.pictures.push(pictureElement);
  }

  renderSlide(image, caption) {
    this.wrapper.innerHTML = this.wrapper.innerHTML + `
      <div class="swiper-slide">
        <div class="background-image" style="background-image: url('${image}')">
        <span class="gallery--caption">${caption}</span>
        </div>
      </div>
    `;
  }

  open() {
    State.preventScrolling(true);

    this.element.classList.add('gallery--open');
    if (!this.galleryInitialized) {
      this.initGallery().then(() => {
        this.open();
      });
    } else {
      this.instance.slideTo(this.swiperStartIndex, 0);
      this.bindEvents();
    }
  }

  close() {
    this.element.classList.remove('gallery--open');
    this.unbindEvents();

    State.preventScrolling(false);
    // State.swapZIndex( document.body.querySelector('.main'), document.body.querySelector('.menu-bar') )
  }

  bindEvents() {
    this.keyListener = window.addEventListener('keydown', (e) => {
      if(e.keyCode === 27) {
        this.close();
      }

      if(e.keyCode === 37) {
        this.instance.slidePrev();
      }

      if(e.keyCode === 39) {
        this.instance.slideNext();
      }
    });

    this.listenToMouse();
  }

  unbindEvents() {
    this.killTimer();
    window.removeEventListener('mousemove', this.resetTimerRef);
    window.removeEventListener('keydown', this.keyListener);
  }

  showCaptions() {
    this.captions.forEach((caption) => {
      caption.classList.add('is-visible');
    });

    this.resetTimer();
  }

  hideCaptions() {
    this.captions.forEach((caption) => {
      caption.classList.remove('is-visible');
      caption.classList.add('is-complete-hidden');
    });

    setTimeout(() => {
      this.captions.forEach((caption) => {
        caption.classList.remove('is-complete-hidden');
      });
    }, 100);
  }
}

for (const element of document.querySelectorAll('.gallery')) {
  element.instance = new Gallery('gallery', element, { onload: true});
}



// WEBPACK FOOTER //
// ./website/components/structures/gallery/gallery.js